export interface CheckboxChangeEventDetail<T = any> {
  checked: boolean;
  value: T;
}
